<template>
  <div
  :style="stablishmentReady() ? {'--bs-primary': stablishment.primaryColor} : ''"
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >

    <notifications></notifications>
    <side-bar
      :title="customerName"

  :style="stablishmentReady() ? {'--bs-danger': stablishment.secondaryColor} : ''"
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      background-color="info"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu :title="userName"></user-menu>
    

      <template slot="links" v-if="isTeacher()">

        <sidebar-item
          :link="{
            name: this.$t('dashboard'),
            icon: 'dashboard',
            path: '/dashboard',
          }"
        >
        </sidebar-item>
        <sidebar-item  :link="{ name: 'Rutinas', icon: 'edit_note' }">

          <sidebar-item 
            class="subitem"
            :link="{ name: 'Explorar', path: '/plannings/explore', icon: 'search'  }"
          >
          </sidebar-item>
          <sidebar-item 
            class="subitem"
            :link="{ name: 'Creadas por mí', path: '/createdbyme', icon: 'edit_note'  }"
          >
          </sidebar-item>
          <sidebar-item  class="subitem"
            :link="{ name: 'Ejercicios', path: '/exercises', icon:'sports_gymnastics' }"
          >
          </sidebar-item>

        </sidebar-item>


        <sidebar-item :link="{ name: this.$t('Clases'), icon: 'sports_kabaddi' }">
        
        <sidebar-item  class="subitem" 
        :link="{ name: 'Actividades', icon: 'sports_kabaddi', path: '/classes' }">
        </sidebar-item>
        <sidebar-item class="subitem" 
        :link="{ name: 'Creadas por mí', icon: 'person', path: '/myclasses' }">
        </sidebar-item>

         

        </sidebar-item>

      </template>


      <template slot="links" v-if="isRestaurant()">
        <sidebar-item
          :link="{
            name: this.$t('dashboard'),
            icon: 'dashboard',
            path: '/dashboard',
          }"
        >
        </sidebar-item>
        <sidebar-item
            v-if="credits != 101"
          :link="{ name: credits + ' ' +this.$t('remainingOrders'), icon: 'diamond', path: '/pricing' }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="credits == 101"
          :link="{ name:  this.$t('unlimitedPlan'), icon: 'diamond', path: '/pricing' }"
        >
        </sidebar-item>

        <sidebar-item
           v-if="hasPermission('stablishmentslist')"
          :link="{
            name: this.$t('stablishments'),
            icon: 'store',
            path: '/stablishments',
          }"
        >
        </sidebar-item>

        <sidebar-item
         v-if="hasPermission('inventorylist')"
          class="w-100"
          :link="{
            name: this.$t('inventory'),
            icon: 'lunch_dining',
            path: '/inventory',
          }"
        >
        </sidebar-item>

        <sidebar-item v-if="hasPermission('menuslist')"
          :link="{ name: this.$t('menus'), icon: 'restaurant', path: '/menus' }"
        >
        </sidebar-item>


        <sidebar-item v-if="hasPermission('orderslist')"
          :link="{ name: this.$t('orders'), icon: 'shopping_cart', path: '/orders' }"
        >
        </sidebar-item>

        <sidebar-item v-if="hasPermission('orderslist')"
          :link="{ name: this.$t('paymentsAndReceipts'), icon: 'receipt_long', path: '/receipts' }"
        >
        </sidebar-item>

        <sidebar-item v-if="hasPermission('qrslist')"
          :link="{ name: this.$t('qrCodes'), icon: 'qr_code_2', path: '/qrs' }"
        >
        </sidebar-item>

        <sidebar-item v-if="hasPermission('userlist')"
          :link="{ name: this.$t('users'), icon: 'group', path: '/users' }"
        >
        </sidebar-item>
      </template>
      <template slot="links" v-if="isGym()">
        <sidebar-item
          :link="{
            name: this.$t('dashboard'),
            icon: 'dashboard',
            path: '/dashboard',
          }"
        >
        </sidebar-item>

         

        <sidebar-item v-if="hasPermission('orderslist')"
          id="accesoslink"
          :link="{ name: 'Accesos', icon: 'sensor_door', path: '/accesses' }"
        >
        </sidebar-item>
        <sidebar-item v-if="hasPermission('orderslist') "
          id="accesoslink"
          :link="{ name: 'Mi tienda', icon: 'store', path: '/inventory' }"
        >
        </sidebar-item>
        <sidebar-item 
      
          :link="{ name: this.$t('settings'), icon: 'settings' }"
        >  

         <sidebar-item
          class="subitem"
          :link="{
            name: this.$t('settings'),
            icon: 'settings',
            path: '/payments',
          }"
        >
          
        </sidebar-item>
        <sidebar-item
          v-if="credits == 101" class="subitem"
          :link="{ name: 'Mí suscripción', icon: 'diamond', path: '/subscribe' }"
        >
        </sidebar-item>
        <sidebar-item v-if="hasPermission('qrslist')" class="subitem"
          :link="{ name: 'QR para las máquinas', icon: 'qr_code_2', path: '/elements' }"
        >
        </sidebar-item>
        <sidebar-item class="subitem"
           v-if="hasPermission('stablishmentslist')"
          :link="{
            name: this.$t('stablishments'),
            icon: 'store',
            path: '/stablishments',
          }"
        >
        </sidebar-item>

        </sidebar-item>



        <sidebar-item  :link="{ name: 'Clientes', icon: 'group' }">
          <sidebar-item v-if="hasPermission('userlist')"
          class="subitem"
            :link="{ name: this.$t('myClients'), icon: 'manage_accounts', path: '/users' }"
          >
          </sidebar-item>
          <sidebar-item v-if="hasPermission('userlist')"
          class="subitem"
            :link="{ name: 'Mi equipo', icon: 'diversity_3', path: '/myteam' }"
          >
          </sidebar-item>
          <sidebar-item v-if="hasPermission('userlist')"
          class="subitem"
            :link="{ name: 'Encuestas', icon: 'assignment', path: '/surveys' }"
          >
          </sidebar-item>
          <sidebar-item v-if="hasPermission('userlist')"
          class="subitem"
            :link="{ name: 'Historial de accesos', icon: 'sensor_door', path: '/accesshistory' }"
          >
          </sidebar-item>
         <sidebar-item 
            v-if="hasPermission('orderslist')"
            class="subitem"
            :link="{ name: 'Solicitudes de pago', icon: 'payment', path: '/myorders' }"
          >
          </sidebar-item>

       
        </sidebar-item>

        <sidebar-item  :link="{ name: this.$t('Rutinas'), icon: 'edit_note' }">

          <sidebar-item 
            class="subitem"
            :link="{ name: 'Creadas por mí', path: '/createdbyme', icon: 'edit_note'  }"
          >
          </sidebar-item>
          <sidebar-item 
            class="subitem"
            :link="{ name: 'Explorar', path: '/plannings/explore', icon: 'search'  }"
          >
          </sidebar-item>
          <sidebar-item  class="subitem"
            :link="{ name: 'Grupos de ejercicios', path: '/training', icon:'workspaces' }"
          >
          </sidebar-item>
          <sidebar-item  class="subitem"
            :link="{ name: 'Ejercicios', path: '/exercises', icon:'sports_gymnastics' }"
          >
          </sidebar-item>
          <sidebar-item  class="subitem"
            :link="{ name: 'Elementos', path: '/elements', icon:'pedal_bike' }"
          >
          </sidebar-item>

        </sidebar-item>


        <sidebar-item :link="{ name: this.$t('Actividades'), icon: 'sports_kabaddi' }">
        
        <sidebar-item class="subitem" 
        :link="{ name: 'Todas', icon: 'sports_kabaddi', path: '/classes' }">
        </sidebar-item>
        <sidebar-item  class="subitem" 
        :link="{ name: 'Creadas por mí', icon: 'person', path: '/myclasses' }">
        </sidebar-item>
        <sidebar-item class="subitem" 
        :link="{ name: 'Calendario de actividades', icon: 'today', path: '/calendar' }">
        </sidebar-item>
         

        </sidebar-item>
       <sidebar-item :link="{ name: 'Preguntas y Soporte', icon: 'support' }">  

        <sidebar-item
          class="subitem"
          :link="{
            name: 'Preguntas frecuentes',
            icon: 'help',
            path: '/tutorials',
          }" >
        </sidebar-item>
        <li   class="subitem">
          <a target="_blank" href="https://chat.whatsapp.com/L32mTz6n8k08sHGvnDnvWU">  
            <small class="ml-2">
                    <md-icon  class="text-primary">support</md-icon> 
                    <p class="text-white">Soporte técnico</p>
            </small>
          </a> 
        </li>

        </sidebar-item>
        <sidebar-item
          v-if="credits != 101 && credits < 40"
          :link="{ name: credits + ' ' + this.$t('remainingAccesses'), icon: 'diamond', path: '/subscribe' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="credits != 101 && credits >= 40"
          :link="{ name: this.$t('subscribe'), icon: 'diamond', path: '/subscribe' }"
        >
        </sidebar-item>



      </template>
      <template slot="links" 
        v-if="isClientGym()">
        <sidebar-item
          :link="{
            name: this.$t('dashboard'),
            icon: 'dashboard',
            path: '/dashboard',
          }"
        >
        </sidebar-item>

     

       
      </template>
      <template slot="links" 
        v-if="isClientGym()">
        <sidebar-item 
        :link="{ name: this.$t('myCalendar'), icon: 'today', path: '/calendar' }">
        </sidebar-item>
        <sidebar-item 
        :link="{ name: this.$t('myClasses'), icon: 'sports_kabaddi', path: '/myclasses' }">
        </sidebar-item>

      </template>
      <template slot="links" 
        v-if="isClientGym()">

        </sidebar-item>
        <sidebar-item  :link="{ name: 'Rutinas', icon: 'edit_note' }">

          <sidebar-item 
            class="subitem"
            :link="{ name: 'Explorar', path: '/plannings/explore', icon: 'search'  }"
          >
          </sidebar-item>
          <sidebar-item 
            class="subitem"
            :link="{ name: 'Creadas por mí', path: '/plannings/onlyme', icon: 'person'  }"
          >
          </sidebar-item>
          <sidebar-item 
            class="subitem"
            :link="{ name: 'Asignadas a mí', path: '/myplannings', icon: 'edit_note'  }"
          >
          </sidebar-item>

        </sidebar-item>
         <sidebar-item
            :link="{ name: 'Solicitudes de pago', icon: 'payment', path: '/myorders' }"
          >
          </sidebar-item>
          <sidebar-item v-if="hasPermission('userlist')"
            :link="{ name: 'Historial de accesos', icon: 'sensor_door', path: '/accesshistory' }"
          >
          </sidebar-item>
      </template>


      <template slot="links" v-if="isGym()">

  



      


      </template>
    </side-bar>
    <div class="main-panel" :class="path">

            <div class="alert alert-danger"
              v-if="credits < 40 && !isClientGym() && subdomain !== 'saucedosgym'"
              style="z-index:1 !important;" 
                :class="[
                  { 'nav-open': $sidebar.showSidebar },
                  { rtl: $route.meta.rtlActive },
                ]">
              <small> {{$t('access_reminder', { credits: this.credits })}}. {{$t('inviteToSubscribe')}}: </small>
               <router-link class="md-primary cursor-pointer" :to="'pricing'" v-if="!isGym()">  
                         <small><strong> {{$t('subscribe')}} </strong> </small>
                        </router-link v-else>   
                        <router-link class="md-primary cursor-pointer" :to="'subscribe'">  
                         <small><strong> {{$t('subscribe')}} </strong> </small>
                        </router-link>  
            </div>

            <div v-if="isDemoResto()" class="alert alert-success"
            
              style="z-index:1 !important;" 
                :class="[
                  { 'nav-open': $sidebar.showSidebar },
                  { rtl: $route.meta.rtlActive },
                ]">
              <srtrong> {{$t('welcome')}}! {{$t('demoMessage')}} </srtrong>
              <a class="btn btn-success" href="https://app.gotake.it/register" target="_blank">{{$t('register')}}</a>
            </div>
           
      
      <div class="marquee-container bg-black border-0" v-if="lastevents.length > 0">
        <div class="marquee">
          <div class="marquee-content ">
            <small v-for="(news, index) in lastevents" :key="index" class="news-item text-white">
              {{ news }}.
            </small>
          </div>
          <!-- Duplicamos solo en CSS para el efecto infinito -->
          <div class="marquee-content" aria-hidden="true">
            <small v-for="(news, index) in lastevents" :key="'dup-' + index" class="news-item text-white">
              {{ news }}.
            </small>
          </div>
        </div>
      </div>

      <div
        class="sidebar mobile sidebar-mobile mb-3 cursor-pointer w-100 bg-white p-0 m-0"
        @click="toggleSidebar"
      >
        <div class="logo bg-white text-right">
          <a
            href="https://gotake.it"
            class="simple-text logotel"
            target="_blank"
          >
            <div  v-if="stablishmentReady()">
              <div class="logomenu" :style="'background:url('+stablishment.logo+')'">
                 
              </div>  
            </div>
            <div v-else class="">
            <svg width="124" height="28" viewBox="0 0 409.6666666666667 93" class="looka-1j8o68f"><defs id="SvgjsDefs1013"></defs><g id="SvgjsG1014" featurekey="symbolContainer" transform="matrix(1,0,0,1,0,0)" fill="#11b5c9">    <rect width="98" height="93"></rect></g><g id="SvgjsG1015" featurekey="monogramFeature-0" transform="matrix(1.4360743561155873,0,0,1.4360743561155873,17.84588846582662,-9.21221178152457)" fill="#ffffff"><path d="M23.28 60.6 c-12.9 0 -21.78 -10.56 -21.78 -21.84 c0 -13.68 10.02 -21.9 20.28 -21.9 c10.14 0 17.64 4.98 17.64 11.1 c0 2.94 -1.92 4.86 -4.8 4.86 c-7.74 0 -8.76 -11.7 -15.54 -11.7 c-4.26 0 -7.02 4.44 -7.02 10.5 c0 11.88 6.18 21.6 13.62 21.6 c1.5 0 2.58 -0.24 3.42 -0.6 l0 -7.86 c0 -2.82 -3.36 -3.48 -3.36 -5.16 l0 -0.24 c0 -0.72 0.72 -1.2 1.56 -1.2 l13.38 0.06 c0.9 0 1.44 0.48 1.44 1.2 l0 0.24 c0 1.68 -2.88 2.34 -2.88 5.16 l0 6.96 c0 1.74 -0.48 2.88 -2.52 4.5 c-2.64 2.1 -7.38 4.32 -13.44 4.32 z"></path></g><g id="SvgjsG1016" featurekey="nameFeature-0" transform="matrix(1.547139083686481,0,0,1.547139083686481,115.21515082973778,6.053186039050097)" fill="#393e46"><path d="M28.92 25.92 c0.6 8.96 -5.52 14.48 -12.8 14.48 c-7.48 0 -14.32 -5.92 -14.32 -14.4 s7 -14.4 14.32 -14.4 c3.52 0 6.72 1.2 9.24 3.32 l-2.04 2.32 c-1.96 -1.56 -4.48 -2.48 -7 -2.48 c-5.72 0 -11.08 4.64 -11.08 11.24 s5.2 11.24 10.88 11.24 c4.96 0 8.92 -2.68 9.68 -8.44 l-8.16 0 l0 -2.88 l11.28 0 z M46.88 11.600000000000001 c7.28 0 14.32 5.92 14.32 14.4 s-7.04 14.4 -14.32 14.4 c-7.32 0 -14.32 -5.92 -14.32 -14.4 s7 -14.4 14.32 -14.4 z M46.88 37.24 c5.48 0 10.88 -4.64 10.88 -11.24 s-5.4 -11.24 -10.88 -11.24 c-5.52 0 -10.88 4.64 -10.88 11.24 s5.36 11.24 10.88 11.24 z M86.72 21.96 l-4.4 0 l0 13.4 c0 1.24 0.48 2 1.68 2 c1.04 0 1.8 -0.24 2.68 -0.64 l0 2.8 c-0.88 0.44 -1.92 0.72 -3.56 0.72 c-2.12 0 -4.04 -0.96 -4.04 -4.6 l0 -13.68 l-2.88 0 l0 -2.76 l2.88 0 l0 -4.88 l3.24 0 l0 4.88 l4.4 0 l0 2.76 z M99.96000000000001 18.84 c3.68 0 6.52 2.04 7.48 4.28 l0 -3.92 l3.28 0 l0 20.8 l-3.28 0 l0 -4 c-0.96 2.4 -3.8 4.4 -7.48 4.4 c-4.72 0 -10.44 -3.56 -10.44 -10.8 c0 -7.16 5.72 -10.76 10.44 -10.76 z M100.32000000000001 21.76 c-3.52 0 -7.6 2.6 -7.6 7.84 c0 5.28 4.08 7.88 7.6 7.88 c3.56 0 7.28 -2.52 7.28 -7.88 c0 -5.32 -3.72 -7.84 -7.28 -7.84 z M130.36 40 l-8.96 -9.28 l-2.84 3 l0 6.28 l-3.28 0 l0 -6.84 l0 -21.44 l3.28 0 l0 17.96 l9.84 -10.48 l3.96 0 l-8.88 9.32 l10.76 11.48 l-3.88 0 z M147.07999999999998 18.84 c4.72 0 11.04 3.6 10.2 11.96 l-17.56 0 c0.52 4.56 4.08 6.8 7.84 6.8 c2.88 0 4.72 -0.8 6.28 -2.32 l1.92 1.76 c-1.88 2.24 -4.6 3.36 -8.24 3.36 c-5.36 0 -11.08 -3.6 -11.08 -10.76 c0 -7.2 5.92 -10.8 10.64 -10.8 z M147.07999999999998 21.68 c-3.08 0 -6.76 2.2 -7.36 6.68 l14.68 0 c-0.4 -4.48 -4.2 -6.68 -7.32 -6.68 z M176.32 11.719999999999999 l0 2.92 l-3.28 0 l0 -2.92 l3.28 0 z M176.32 19.2 l0 20.8 l-3.28 0 l0 -20.8 l3.28 0 z M190.32 21.96 l-4.4 0 l0 13.4 c0 1.24 0.48 2 1.68 2 c1.04 0 1.8 -0.24 2.68 -0.64 l0 2.8 c-0.88 0.44 -1.92 0.72 -3.56 0.72 c-2.12 0 -4.04 -0.96 -4.04 -4.6 l0 -13.68 l-2.88 0 l0 -2.76 l2.88 0 l0 -4.88 l3.24 0 l0 4.88 l4.4 0 l0 2.76 z"></path></g></svg>
            </div>
          </a>
          <span class="text-right menu-container">

            <md-button class="md-info md-simple md-just-icon">

              <i class="material-icons" v-if="!$sidebar.showSidebar">menu</i>
              <i class="material-icons" v-if="$sidebar.showSidebar">close</i>
            </md-button>
          </span>
        </div>
      </div>



      <fixed-plugin
        v-if="false"
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>
      
  

      <div :class="{ content: !$route.meta.hideContent }">
        <div class="text-white px-2 pb-2"
          v-if="isDemoGym()">
          <h6>{{obtenerSaludo()}}. Si te gusta la demo podés armar tu propia aplicación registrandote acá:  <a class="btn btn-primary btn-sm mt-2" href="https://app.gotake.it/register/gym" target="_blank">{{$t('register')}}</a></h6>      
        </div>

        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import permissionsMixin from '@/mixins/permissionsMixin';


import ContentFooter from "./ContentFooter.vue";
import FixedPlugin from "../../FixedPlugin.vue";
import { getCredits } from "@/pages/Orders/actions";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import { getProfileStablishmentsAction } from "@/pages/Stablishments/actions";

import { getLastsEvents } from "@/pages/Dashboard/actions";


export default {

  mixins: [permissionsMixin],
  components: {
    ContentFooter,
    FixedPlugin,
    UserMenu,
    ZoomCenterTransition,
  },
  created() {


      this.customerName = localStorage.getItem('stablishmentname')

      let subdomain = window.location.hostname;
      const parts = subdomain.split(".");
      this.subdomain = parts[0];

        this.role = localStorage.getItem('role');

      if(this.role =='gym') {
         getLastsEvents().then((result) => {
                 this.lastevents = result.data
          });
      }


    this.getCreditsNow()
    this.path = this.$route.name;
    window.addEventListener('beforeinstallprompt', (e) => {
      // Evita que el mini-infobar aparezca en dispositivos móviles
      e.preventDefault();
      // Guarda el evento para que se dispare más tarde
      this.deferredPrompt = e; 
        // Verifica si la aplicación no está ya instalada
        if (!window.matchMedia('(display-mode: standalone)').matches) {
          this.showInstallButton = true;
        }
    });

    this.getStablishments();

  },
  data() {
    return {
      lastevents: [],
      role: false,
      customerName: false,
      subdomain:'',
      credits: 'none',
      planingkey: 1223,
      path: "",
      deferredPrompt: null,
      showInstallButton: false,
      sidebarBackgroundColor: "black",
      sidebarBackground: "rose",
      sidebarBackgroundImage: "/img/sidebar-3.jpg",
      sidebarMini: true,
      sidebarImg: false,
      userName: "", // nueva propiedad para el nombre de usuario
      allStablishments:false,
      stablishment: false,
    };
  },
  methods: {  
    obtenerSaludo() {
        const hora = new Date().getHours();
        
        if (hora >= 6 && hora < 12) {
            return "¡Buen día!";
        } else if (hora >= 12 && hora < 18) {
            return "¡Buenas tardes!";
        } else {
            return "¡Buenas noches!";
        }
    },
    hasElement(className) {
        return document.getElementsByClassName(className).length > 0;
      },

     initScrollbar(className) {
        if (this.hasElement(className)) {
          new PerfectScrollbar(`.${className}`);
          document.getElementsByClassName(className)[0].scrollTop = 0;
        } else {
          // try to init it later in case this component is loaded async
          setTimeout(() => {
            this.initScrollbar(className);
          }, 100);
        }
      },

     reinitScrollbar() {
        let docClasses = document.body.classList;
        let isWindows = navigator.platform.startsWith("Win");
        if (isWindows) {
          // if we are on windows OS we activate the perfectScrollbar function
          this.initScrollbar("sidebar");
          this.initScrollbar("sidebar-wrapper");
          this.initScrollbar("main-panel");

          docClasses.add("perfect-scrollbar-on");
        } else {
          docClasses.add("perfect-scrollbar-off");
        }
      },
    async getStablishments(){

      const stablishmentsResponse = await getProfileStablishmentsAction();
      const allStablishments = stablishmentsResponse.stablishments;
      if(allStablishments){
      this.stablishment = allStablishments[0];

      

        if(this.stablishment && this.stablishment.primaryColor == '#FFFFFF' ||
        this.stablishment.primaryColor == '#ffffff' || 
        !this.stablishment.primaryColor){
          this.stablishment.primaryColor = '#333';
        }
        if(this.stablishment && this.stablishment.secondaryColor == '#FFFFFF' ||
        this.stablishment.secondaryColor == '#ffffff' || 
        !this.stablishment.secondaryColor){
          this.stablishment.secondaryColor = '#333';
        }
     

      }
      if(this.stablishmentReady()){
        // Cambiar el título de la página
        document.title = this.stablishment.name;
        // Cambiar el favicon de la página
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = this.stablishment.logo;
        document.head.appendChild(link);
      }else{
           document.title = 'GO Take IT';
      }
    },
    stablishmentReady(){
        return (
          this.role == 'client' &&
          this.stablishment.name !== 'My Fitness' &&
          this.stablishment.name !== 'Costa Azul' && 
          this.stablishment !== undefined )
    },
    async getCreditsNow(){
      const { ok,credits } = await getCredits();
      this.credits = credits
    },
    async installPWA() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;
        this.deferredPrompt = null;     
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);

    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  updated() {
    this.reinitScrollbar();
  },
  mounted() {
    this.reinitScrollbar();
    this.userName = localStorage.getItem("name") || "Anonymous"; // asignar el valor de localStorage a userName

    if(this.userName !== "Anonymous"){
      const userName = this.userName + ' - ' + localStorage.getItem('restaurant');
    }
    const userRestaurant = localStorage.getItem('restaurant');

   
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>

<style lang="scss" scoped>
.alert{
  margin-bottom: 1px !important;
}
.sidebar .credits .md-icon.md-theme-default.md-icon-font,
.credits i{
    font-size: 10px !important;
    color: #11b5c9 !important;
    margin:0;
}

.credits{
float: left;
    margin-left: 28px;
    font-size: 11px;
    margin-top: -5px;
    color: #11b5c9 !important;
    overflow: hidden;
    height: 19px;
}
.md-button.md-info.md-simple i {
    color: #424242 !important;
}
</style>
<style lang="scss">
    .sidebar.mobile {
        overflow: hidden !important;
    }
.md-field:before {
  background-color: none !important;
  background: none !important;
}

.sidebar-mobile i {
  font-size: 35px !important;
  margin-right: 17px;
  margin-bottom: 11px;
}

.sidebar.mobile {
  position: relative;
  float: left;
  width: 100% !important;
  overflow-y: auto;
  right: auto;
  top: auto;
  left: auto;
  height: 67px;
  transform: none;
}

.image-container {
  max-width: 400px;
}

.error-message {
  color: red;
  margin-top: 10px;
}

.sidebar-mini .sidebar {
  z-index: 100 !important;
}

.sidebar.mobile {
  display: none; // Oculto por defecto

  @media (max-width: 980px) {
    display: block; // Mostrar solo en pantallas pequeñas
  }
}

.menu-container {
  margin-right: 10px;
  cursor: pointer;
}
.menu-language {
    padding: 0px;
}
.menu-language.md-field input{
    border-bottom:0 !important;
}

.md-select {
  color: white !important;
}

.menu-toggle {
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1000;
  cursor: pointer;
  font-size: 24px;
  display: none; // Oculto por defecto

  @media (max-width: 768px) {
    display: block; // Mostrar solo en pantallas pequeñas
  }
}

.menu-toggle i {
  color: #fff;
}

.nav-open .menu-toggle i {
  color: #000;
}

.language-select {
  margin: 10px;
}

.sidebar .sidebar-wrapper .md-field.md-theme-default.md-focused .md-input,
.sidebar .sidebar-wrapper .md-field.md-theme-default.md-focused .md-textarea,
.sidebar .sidebar-wrapper .md-field.md-theme-default.md-has-value .md-input,
.sidebar .sidebar-wrapper
  .md-field.md-theme-default.md-has-value
  .md-textarea
  .md-field.md-theme-default.md-has-value
  .md-input,
.sidebar .sidebar-wrapper .md-field .md-input {
  -webkit-text-fill-color: white !important;
}
.sidebar .sidebar-wrapper .md-field .md-input,
.sidebar .sidebar-wrapper .md-field .md-textarea {
  -webkit-text-fill-color: white !important;
}

.sidebar .sidebar-wrapper .md-icon.md-theme-default.md-icon-image svg {
  fill: white !important;
}

.logotel{
      margin-left: 9px;
    margin-top: -4px;
    float: left;

}

.language-select select {
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
</style>


<style>

.btn-primary,
.md-button.md-primary, 
.md-button.md-primary:hover, 
.md-button.md-primary:focus, 
.md-button.md-primary:active, 
.md-button.md-primary.active, 
.md-button.md-primary:active:focus, 
.md-button.md-primary:active:hover, 
.md-button.md-primary.active:focus, 
.md-button.md-primary.active:hover, 
.open > .md-button.md-primary.dropdown-toggle, 
.open > .md-button.md-primary.dropdown-toggle:focus, 
.open > .md-button.md-primary.dropdown-toggle:hover {
    background-color: var(--bs-primary) !important;
    border-color: var(--bs-primary) !important;
}

.subitem{
  padding-left: 13px !important;
}

.text-primary {
    color: var(--bs-primary) !important;
}
.badge.badge-primary {
 
    background-color: var(--bs-primary) !important;
}

.sidebar[data-color=rose] li.active > a:not([data-toggle=collapse]), .off-canvas-sidebar[data-color=rose] li.active > a:not([data-toggle=collapse]) {
   background-color: var(--bs-primary) !important;
   box-shadow: none;
}
.sidebar .nav li {
    width: 100% !important;

}
</style>


<style scoped>
.marquee-container {
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
}

.marquee {
  display: flex;
  width: max-content;
  animation: marquee-scroll 60s linear infinite;
}

.marquee-content {
  display: flex;
}

.news-item {
  padding: 0 20px;
}

/* Animación de desplazamiento */
@keyframes marquee-scroll {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-50%);
  }
}
</style>